import NetworkLayer from './networkLayer';

class UtilityFactory {

  constructor() {
    this._networkLayer = new NetworkLayer();
  }

  get networkLayer() {
    return this._networkLayer;
  }

}

export const utility = new UtilityFactory();
export default utility;



// WEBPACK FOOTER //
// ./src/utilites/index.js